import { IPage } from 'components/activity/models';

export enum EReviewSourceType {
    WEB_UI_ORDER_CONFIRMATION = 'WEB_UI_ORDER_CONFIRMATION'
}

export interface ICreateReviewRequest {
    tenantId: string;
    locationId: string;
    orderId: number;
    rating: number;
    text?: string;
    source: {
        type: EReviewSourceType;
    };
    userId: string;
}

export interface IUpdateReviewRequest {
    rating: number;
    text?: string;
}

export interface IReview {
    _id: string;
    tenantId: string;
    locationId: string;
    userId: string;
    orderId: number;
    rating: number;
    text: string;
    source: {
        type: EReviewSourceType;
        platform: string;
    };
    createdAt: string;
    updatedAt: string;
}

export interface IReviewsResponse {
    items: IReview[];
    page: IPage;
}
